module.exports = __webpack_public_path__ + "static/media/blacktick.8d073d04.svg";